import { z } from "zod";

const envSchema = z.object({
  REACT_APP_API_URL: z.string().url(),
  REACT_APP_SERVER_URL: z.string().url(),
  REACT_APP_GOOGLE_CLIENT_ID: z.string(),
  REACT_APP_RECAPTCHA_SITE_KEY: z.string(),
  REACT_APP_NEWRELIC_LICENSE_KEY: z.string(),
  REACT_APP_NEWRELIC_APPLICATION_ID: z.string(),
  REACT_APP_NEWRELIC_ACCOUNT_ID: z.string(),
  REACT_APP_NEWRELIC_TRUST_KEY: z.string(),
  REACT_APP_NEWRELIC_AGENT_ID: z.string(),
  REACT_APP_AMAZON_APP_ID: z.string(),
  REACT_APP_ENV: z.string(),
});

export const parsedSchema = envSchema.parse(process.env);

export const env = {
  API_BASE_URL: parsedSchema.REACT_APP_API_URL,
  SERVER_URL: parsedSchema.REACT_APP_SERVER_URL,
  GOOGLE_CLIENT_ID: parsedSchema.REACT_APP_GOOGLE_CLIENT_ID,
  RECAPTCHA_SITE_KEY: parsedSchema.REACT_APP_RECAPTCHA_SITE_KEY,
  NEWRELIC_LICENSE_KEY: parsedSchema.REACT_APP_NEWRELIC_LICENSE_KEY,
  NEWRELIC_APPLICATION_ID: parsedSchema.REACT_APP_NEWRELIC_APPLICATION_ID,
  NEWRELIC_ACCOUNT_ID: parsedSchema.REACT_APP_NEWRELIC_ACCOUNT_ID,
  NEWRELIC_TRUST_KEY: parsedSchema.REACT_APP_NEWRELIC_TRUST_KEY,
  NEWRELIC_AGENT_ID: parsedSchema.REACT_APP_NEWRELIC_AGENT_ID,
  AMAZON_APP_ID: parsedSchema.REACT_APP_AMAZON_APP_ID,
  APP_ENV: parsedSchema.REACT_APP_ENV,
} as const;
